<template>
  <div class="relative z-50 h-[20%] w-full">
    <div
      class="flex h-[25%] px-4 items-center"
      :class="{ 'justify-end': locale === 'ar' }"
    >
      <h1 class="md:text-[1.25vw] text-[4vw] font-bold text-white">
        {{ title }}
      </h1>
    </div>
    <div class="flex h-[75%] flex-col items-center justify-evenly text-white">
      <div
        class="flex h-[55%] w-[90%] flex-wrap md:min-h-8 items-center justify-center rounded-lg border-2 border-saudi-purple/50 bg-saudi-dark"
      >
        <h1 class="font-bold">{{ selectedForm }}</h1>
        <dropdown-menu withDropdownCloser>
          <template #trigger>
            <div class="w-full h-full flex justify-center">
              <div class="flex w-full cursor-pointer">
                <img
                  src="../assets/icons/arrowThick.svg"
                  class="hover-effect p-2"
                />
              </div>
            </div>
          </template>
          <template #body>
            <ul
              class="absolute right-0 top-[16vh] flex p-2 flex-wrap justify-center gap-2 rounded-lg bg-saudi-dark font-bold"
            >
              <li
                class="relative flex h-[6vh] w-[48%] cursor-pointer"
                v-for="option in options"
                :key="option.value"
                @click="selectFormation(option)"
              >
                <a
                  dropdown-closer
                  class="flex w-full cursor-pointer items-center justify-center rounded-lg border-2 bg-zinc-900 border-saudi-dark p-2 transition-colors hover:border-[#cf70cf]"
                  :class="
                    selectedFormId === option.id
                      ? 'bg-saudi-purple'
                      : 'bg-saudi-dark'
                  "
                >
                  {{ option.label }}
                </a>
              </li>
            </ul>
          </template>
        </dropdown-menu>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import DropdownMenu from "v-dropdown-menu";

defineProps({
  modelValue: String,
  options: Array,
  title: String,
  locale: String,
});

const emit = defineEmits(["update:modelValue"]);

const selectedForm = ref("4-4-2");
const selectedFormId = ref(4);

const selectFormation = (option) => {
  selectedForm.value = option.label;
  selectedFormId.value = option.id;

  emit("update:modelValue", option.value);

  if (typeof window.gtag === "function") {
    window.gtag("event", "select_formation", {
      event_category: "Formation",
      formation_id: option.id,
      formation: option.label,
      value: 1,
    });
  }
};
</script>

<style>
.hover-effect {
  transition: all 0.3s ease;
}

.hover-effect:hover {
  filter: saturate(100%) invert(35%) sepia(10%) hue-rotate(50deg)
    brightness(103%) contrast(0%);
}
</style>
